// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CalendarFilledSvg from "@fishx/icons-svg/es/asn/CalendarFilled";
import FishxIcon from '../components/FishxIcon';

var CalendarFilled = function CalendarFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CalendarFilledSvg
  }));
};

CalendarFilled.displayName = 'CalendarFilled';
export default React.forwardRef(CalendarFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CalendarFilled.js
// module id = 2143
// module chunks = 0